module.exports = __webpack_public_path__ + "img/phone.ba00e519.svg";